









import Vue from 'vue'
import AppSnackBar from '@/components/appBase/AppSnackBar.vue'

export default Vue.extend({
  name: 'App',
  components: { AppSnackBar },
})
